module.exports = __webpack_public_path__ + "img/icon-try-on.dark.106f968e.svg";